import dataManager from "./data-manager";
import dashboard from "./dashboard";
import account from "./account";
import shared from "./shared";
import graph from "./graph";
import auth from "./auth";
import assistant from "./assistant";
import cate from "./cate";
import rca from "./rca";
import augmentation from "./augmentation";

const en = {
  translation: {
    "btn-regist": "Register",
    "btn-edit": "Edit",
    "btn-delete": "Delete",
    "btn-back": "Back",
    "btn-billing": "Subscribe",
    "btn-send": "Send",
    "btn-confirm": "Confirm",
    "btn-regist2": "Register",
    "btn-card": "Add Credit Card",
    "btn-add": "Add",
    "btn-mail": "Mail",
    "btn-plan-cancel": "Unsubscribe",
    "btn-leave": "Withdrawal",
    "btn-ok": "OK",

    "support-manual": "Manual Download",
    "support-manual-basic": "Manual (Causal Inference Basic Version)",
    "support-manual-advanced": "Manual (Causal Inference Advanced Version)",
    "support-whitepaper": "White Paper Download",
    "support-whitepaper-basic": "White Paper (Causal Inference Basic Version)",
    "support-whitepaper-advanced":
      "White Paper (Causal Inference Advanced Version)",

    "regist-vendor-title": "Company Information Registration",
    "vendor-name": "Company",
    "vendor-postcode": "Postal Code",
    "vendor-address": "Address",
    "vendor-department": "Department",
    "vendor-position": "Job Title",
    "vendor-manager": "Full Name",
    "vendor-phone": "Telephone",
    "vendor-email": "Email",
    "vendor-logo": "Company Logo",
    "vendor-comma": ", ",

    "vendor-country": "Country",
    "vendor-prefecture": "Prefecture",
    "vendor-city": "City",

    "vendor-plan-1-months": "1 Months",
    "vendor-plan-6-months": "6 Months",
    "vendor-plan-1-year": "1 Year",

    "vendor-plan-trial-light": "Lite Plan",
    "vendor-plan-basic": "Basic Plan",
    "vendor-plan-flex": "Flex Plan",
      "vendor-plan-multi": "Multi-Project Plan",

    "vendor-plan-standard": "xCausal™ Standard (Standard Edition)",
    "vendor-plan-standard-desc":
      "BI dashboards\nCausal Discovery (3 algorithms available) * Plans to add more\nCausal Inference (Structural Causal Model base)\nSmallytics Algorithm\nMixed use of discrete and continuous values\nNatural Direct Effect (NDE) Natural Indirect Effect (NIE) \nRobustness Test\nRoot Cause Analysis(RCA) \nConditional ATE(CATE) \nModeling via AI Agents",

    "vendor-plan-healthcare": "xCausal™ for Healthcare (Healthcare Edition)",
    "vendor-plan-healthcare-desc":
      "BI dashboards\nCausal Discovery (3 algorithms available) * Plans to add more\nCausal Inference (Structural Causal Model base)\nSmallytics Algorithm\nMixed use of discrete and continuous values\nNatural Direct Effect (NDE) Natural Indirect Effect (NIE) \nRobustness Test\nRoot Cause Analysis(RCA) \nConditional ATE(CATE) \nModeling via AI Agents\nHealth Care Dashboard\nScientific Paper Search function\nCKE-LLM (Causal Knowledge Extraction LLM / MSD manual available)\nUse of you'd™ application and data linkage",

    "vendor-plan-code": '"Number of Data" based pricing Plan',
    "vendor-plan-code-desc":
      "Base Fee + Charges Based on Number of Data (Number of samples)\nThe basic service fee includes up to 5 accounts",

    "vendor-plan-cap": '"Data Capacity" based pricing Plan',
    "vendor-plan-cap-desc":
      "Base Fee (includes up to 1GB) + Charges Based on additional data capacity (in 1GB increments)\nThe basic service fee includes up to 5 accounts\n15% discount on the first year's basic fee if you agree to provide references",

    "vendor-plan-lite": "Lite Plan",
    "vendor-plan-lite-desc":
      "Base Fee only (includes up to 100KB)\nOne account only\nFree trial for 1 week *Automatic billing begins after free trial\nThis plan requires a review of your registration information.",

    "vendor-plan-reference":
      "*Please contact us individually if you are willing to cooperate with our references.",

    "vendor-plan-5-accounts": "・5 accounts (including administrator)",
    "vendor-plan-personal-codes": "・Provide personal codes for user linkage",
    "vendor-plan-healthcare-dashboard": "・Healthcare Dashboard",
    "vendor-plan-user-health-dashboard": "・User health dashboard (individual)",
    "vendor-plan-data-upload": "・Upload your own data",
    "vendor-plan-causal-basic": "・Causal Inference Basic Version",
    "vendor-plan-bayesian-version": " Bayesian Network Version",
    "vendor-plan-10-nodes-included": " (Up to 10 nodes) ",
    "vendor-plan-1-month-free": " 1 Month Free Trial (5 Nodes)",
    "vendor-plan-6-month-plan": "6 Month Plan",
    "vendor-plan-1-year-plan": "1 Year Plan",
    "vendor-plan-basic-charge": "Basic Charge:",
    "vendor-plan-additional-fee": "Additional Fee:",
    "vendor-plan-150000": "150,000円",
    "vendor-plan-240000": "240,000円",
    "vendor-plan-375000": "375,000円",
    "vendor-plan-600000": "600,000円",
    "vendor-plan-per-user": "Per User:",
    "vendor-plan-150-month": "150円 / Month",
    "vendor-plan-200-month": "200円 / Month",
    "vendor-plan-300-month": "300円 / Month",
    "vendor-plan-400-month": "400円 / Month",
    "vendor-plan-future-release": "Scheduled for Future Release",
    "vendor-plan-add-accounts": "Add Accounts",
    "vendor-plan-5-set": " (5 Accounts)",
    "vendor-plan-sets-of-5":
      "Additional accounts can be purchased in sets of 5.",
    "vendor-plan-quantity": "Quantity",
    "vendor-plan-confirm-changes": "Confirm",
    "vendor-plan-contract-details-title": "Contract Details Confirmation",
    "vendor-plan-contract-service": "Contract Service",
    "vendor-plan-contract-service-detail":
      "Fees are billed as a basic fee for the contract period (lump-sum payment) and a monthly fee (monthly payment) based on the number of app-linked users.",
    "vendor-plan-service-menu-basic": "Service Menu Basic Charge",
    "vendor-plan-contract-period": "Contract Period",
    "vendor-plan-basic-charge-2": "Basic Charge",
    "vendor-plan-no-change": " (no change)",
    "vendor-plan-total": "Total",
    "vendor-plan-monthly-code-fee": '"Number of Data" based pricing Plan',
    "vendor-plan-monthly-cap-fee": 'Usage Fee',
    "vendor-plan-monthly-usage-fee": "Monthly Charge",
    "vendor-plan-monthly-code-fee-per":
      "Charges Based on Number of Data (Number of samples)",
    "vendor-plan-monthly-cap-fee-per": "per 100,000 dp",

    "vendor-plan-service-changed": "Service Updated",
    "vendor-plan-service-change-1":
      "We have updated the content of the contract.",
    "vendor-plan-service-change-2":
      "Please wait a moment until it is reflected on the dashboard.",

    "vendor-plan-usage-fee": "Usage Fee",
    "vendor-plan-max-data-points": "Maximum Data Point Usage",
    "vendor-plan-data-augmentation-fee": "Data Augmentation Fees",
    "vendor-plan-causal-ai-fee": "Causal AI Assistant Fees",

    "plan-desc-health-5":
      "you'd app user statistics available (individual quotation)",
    "plan-desc-opt-basic-1": "・Node recommendation by Smallytics",
    "plan-desc-opt-basic-2": "・Bayesian network",
    "plan-desc-opt-basic-3": "・Used by discretization (discrete values only)",
    "plan-desc-opt-advance-1": "・Node recommendation by Smallytics",
    "plan-desc-opt-advance-2": "・Bayesian network/SCM",
    "plan-desc-opt-advance-3": "・Mixed use of discrete and continuous values",
    "plan-desc-opt-advance-4":
      "・Natural Direct Effect (NDE) Natural Indirect Effect (NIE)",
    "plan-desc-opt-advance-5": "・Robustness evaluation",
    "plan-desc-opt-advance-6": "・Journal search function",

    "plan-period-1-month": "Monthly plan",
    "plan-period-6-month": "Half year plan",
    "plan-period-1-year": "Annual plan",
    "plan-price-table-1-1":
      "xCausal® Platform Fee",
    "plan-price-table-1-1-1": "Up to 5 User Accounts",
    "plan-price-table-1-1-2": "Up to 5 User Accounts\nIncludes 50 Million Data Points",
    "plan-price-table-1-1-3": "Price (Up to 100,000 dp)\n1 User Account",
    "plan-price-table-1-2":
      "xCausal® Platform Fee",
    "plan-price-table-2-1": "Basic fee",
    "plan-price-table-2-2":
      "Additional accounts",
    "plan-price-table-2-3": "Usage Fee (per 100,000 dp*)\n*dp (data points) are equivalent to the number of table cells.",

    "plan-expansion-desc": "Data Augmentation Pricing\nxCausal® offers a Data Augmentation feature that generates large-scale synthetic datasets from a causal model built using a small seed dataset (original data). In addition to the xCausal® platform fee, a usage charge is incurred each time the Data Augmentation feature is executed.\nUsage is billed in increments of 100,000 data points (dp).",
    "plan-expansion-title": "Data Augmentation Pricing",
    "plan-expansion-table-1-1": "Data Augmentation Pricing",
    "plan-expansion-table-1-2": "Data Augmentation Fees (Synthetic Data Generation)",
    "plan-expansion-table-2-1": "Category",
    "plan-expansion-table-2-2": "Subscription Term",
    "plan-expansion-table-2-3": "Terms",
    "plan-expansion-table-2-4": "Fee per Execution (100,000 dp)",

    "plan-price-table-cap-1-1-2": "Includes 5 accounts and up to 1GB charge",
    "plan-price-table-cap-2-2":
      "Charges based on the additional data capacity (in 1 GB increments)",

    "plan-youd-option": "you’d linkage option",
    "youd-content-title-1": "",
    "youd-content-title-2": "",
    "youd-content-title-3": "you'd Integration Analytics Service",
    "youd-content-guide-1-1": "",
    "youd-content-guide-1-2": "you'd™︎",
    "youd-content-guide-1-3":
      " is a conditioning AI application that analyzes various information such as life logs accumulated on smartphones from wearable devices, records of physical condition and habits entered by yourself, and environmental data such as weather and atmospheric pressure.",
    "youd-content-guide-2-1": "By integrating with ",
    "youd-content-guide-2-2": "you'd™︎",
    "youd-content-guide-2-3":
      " and combining it with proprietary data held by the subscriber’s company, more advanced and customized data analysis becomes possible. This enables more accurate analysis results and insights for business decision-making and strategy formulation.",
    "youd-contenxt-popup":
      "If you want to choose the you’d linkage option, we require you apply for it when you sign up. The you’d is free app. It is not possible to switch to the you’d linkage option during the contract. If you want to switch in the middle of your contract, you will need to do the initial setup. Please kindly note in advance.",

    "vendor-plan-monthly-cap-1": "",
    "vendor-plan-monthly-cap-2":
      "Monthly conversion \nwhen number of data points",

    "regist-vendor-plan-custom":
      "Estimates and customization other than those listed above",
    "regist-vendor-plan-custom-desc": "Please contact us for custom pricing if you require the Causal AI Assistant or any custom development, implementation, or integration services.",
    "regist-vendor-inquiry": "Contact Us",

    "regist-vendor-complete-title": "Completion of Company Registration",
    "regist-vendor-complete-message":
      "We are processing the payment. \nPlease wait a moment.",
    "regist-vendor-inspection-title": "Confirming Company Information",
    "regist-vendor-inspection-message": "Checking. \nPlease wait a moment.",
    "regist-vendor-ready-title": "Company Information Confirmation Complete",
    "regist-vendor-ready-message":
      "Your company information has been confirmed. Please register your payment information.",
    "regist-vendor-select-service": "Select your service and pricing plan",
    "regist-vendor-select-service-desc": "xCausal® Features\n\nThe Causal AI platform xCausal® provides the following causal inference capabilities as standard features:\n\nDashboard\nCausal Discovery (Multiple Algorithms)\nCausal Inference (Average Treatment Effect [ATE] / Stratified Average Treatment Effect)\nSmallytics Causal Variable Recommendation\nNatural Direct Effect (NDE) / Natural Indirect Effect (NIE) Estimation\nRobustness Evaluation\nRoot Cause Analysis (RCA)\nConditional Average Treatment Effect (CATE)\nAI Assistant with Conversational Interface and AI Agents\nData Augmentation\n\nAbout \"Data Points\" in xCausal® Pricing Plans\nxCausal® processes tabular data. A data point is equivalent to a single table cell and is calculated using the following formula.\n\nWithin xCausal®, data points may also be abbreviated as dp.\n\nData Points (Number of Cells) = Number of Rows × Number of Columns\n\nIn xCausal®, 100,000 data points (dp) constitute one unit of usage-based billing.\n\nxCausal® Platform Pricing\nxCausal® offers four platform pricing plans: the Lite Plan for evaluation purposes, the Basic Plan and Flex Plan as standard subscription options, and the Multi-Project Plan for organizations managing multiple projects. Each plan offers three contract terms: 1 month, 6 months, and 1 year. The longer the contract term, the lower the monthly equivalent cost. Please note that contracts cannot be canceled during the contract period and payment must continue throughout.\n\nLite Plan\nA fixed-price plan with no usage-based charges.\n・Includes up to 100,000 data points (dp)\n・Available for one user account only\n・Payment by credit card only\n・Includes a one-week free trial, making it ideal for evaluation purposes\nUsage charges are calculated based on your monthly usage and billed at the end of each month.\n\nBasic Plan\nA plan consisting of a base subscription fee plus usage-based pricing.\n・Usage is billed in increments of 100,000 data points (dp)\n・Includes up to five analyst accounts\n・Recommended for organizations with smaller datasets\nUsage charges are calculated based on your monthly usage and billed at the end of each month.\n\nFlex Plan\nA plan that includes a fixed monthly fee covering up to 50 million data points, with additional usage billed on a pay-as-you-go basis.\n・Includes up to 50 million data points in the base fee\n・Additional usage is billed in increments of 100,000 data points (dp)\n・Includes up to five analyst accounts\n・Recommended for organizations with large datasets\n\nMulti-Project Plan\nA plan designed for organizations managing multiple projects and databases.\n・Supports up to five projects (multiple databases)\n・A dedicated instance is provisioned, so setup may require additional lead time\n・Available under annual contracts only\n・Please contact us for pricing and availability\n\n* 10% discount on the first year's basic fee will be applied for customers who allow us to publish them as a reference. Please contact us for details.",

    "regist-vendor-choose": "Continue",
    "regist-vendor-warnings-1": "xCausal can be used by uploading your data.",
    "regist-vendor-warnings-2":
      "It is also possible to use our conditioning application you'd™ to acquire and link your lifelog.",
    "regist-vendor-warnings-3": "In this case, the linkage flow is as follows.",

    "regist-vendor-alt-1":
      "Connection between individuals・medical care・ cloud",
    "regist-vendor-step": "Step",
    "regist-vendor-flow-0":
      "To use the xCausal™ Service, you must first register on the web to open an account.",
    "regist-vendor-flow-1":
      "Obtain the identification code issued on the xCausal™ portal site and prepare to distribute it to your company's individual users (or patients). Link the obtained identification code to the company's user information, such as e-mail address, etc., for management.",
    "regist-vendor-flow-2":
      "Distribute identification codes to your own individual users via email. The key to this process is to ensure a sufficient number of users and comprehensive data. We recommend that there be at least 30 users who have records for all data items to be analyzed.",
    "regist-vendor-flow-3":
      "After receiving the identification code, the user will first download the app in order to exchange data through our personal conditioning app you'd™ (or you'd's OEM app). (Please search for \"you'd\")",
    "regist-vendor-flow-4":
      "After receiving the identification code, the user enters the identification code on the identification code entry screen that appears on the you'd™ app and agrees on the app screen to provide his/ her health data and lifelog and to link it to the data in the sending company or medical institution.",
    "regist-vendor-flow-5":
      "After acceptance, the personal user data captured by the you'd™ app will be uploaded to the cloud.",
    "regist-vendor-flow-6":
      "Upload your company's data in csv format from the xCausal™ portal's data linkage page.",
    "regist-vendor-flow-7":
      "The data will be linked with an identification code. (This mechanism does not require the provision of personal information.) After data linkage, the user will be able to use the xCausal™ service in an anonymized and statisticized form. The available data will be the health data in the user's iOS™ Health Care or GoogleFit when the Android™ version is released, as well as the data on physical condition, symptoms, and habits entered by the user in “you'd™”. For items with a small number of users, the data will be displayed when the number of people and data are sufficient.",
    "regist-vendor-flow-9":
      "You can use this service to develop products and services for your own individual users or new individual users, online medical services, IoT services, etc.",
    "regist-vendor-logo-skip": "Upload later",

    PLAN_ID_PLUGIN_1M: "Health data plug-in service (for general businesses)",
    PLAN_ID_PLUGIN_6M: "Health data plug-in service (for general businesses)",
    PLAN_ID_PLUGIN_1Y: "Health data plug-in service (for general businesses)",
    PLAN_ID_MEDICAL_1M:
      "Medical Assist Service (for physicians and medical institutions)",
    PLAN_ID_MEDICAL_6M:
      "Medical Assist Service (for physicians and medical institutions)",
    PLAN_ID_MEDICAL_1Y:
      "Medical Assist Service (for physicians and medical institutions)",
    PLAN_ID_DE_BASIC_1M: "Causal Inference / Basic Version",
    PLAN_ID_DE_BASIC_6M: "Causal Inference / Basic Version",
    PLAN_ID_DE_BASIC_1Y: "Causal Inference / Basic Version",
    PLAN_ID_DE_ADVANCED_1M: "Causal Inference / Advanced Version",
    PLAN_ID_DE_ADVANCED_6M: "Causal Inference / Advanced Version",
    PLAN_ID_DE_ADVANCED_1Y: "Causal Inference / Advanced Version",

    PLAN_ID_CODE_BASIC_1M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_BASIC_6M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_BASIC_12M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_ADVANCED_1M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CODE_ADVANCED_6M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CODE_ADVANCED_12M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_BASIC_1M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_BASIC_6M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_BASIC_12M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_ADVANCED_1M: " 容量課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_ADVANCED_6M: " 容量課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_ADVANCED_12M: " 容量課金プラン アドバンス・バージョン",

    PLAN_ID_CODE_STANDARD_1M:
      'xCausal™ Standard (Standard Edition) "Number of Data" based pricing',
    PLAN_ID_CODE_STANDARD_6M:
      'xCausal™ Standard (Standard Edition) "Number of Data" based pricing',
    PLAN_ID_CODE_STANDARD_12M:
      'xCausal™ Standard (Standard Edition) "Number of Data" based pricing',
    PLAN_ID_CAP_STANDARD_1M:
      'xCausal™ Standard (Standard Edition) "Data Capacity" based pricing',
    PLAN_ID_CAP_STANDARD_6M:
      'xCausal™ Standard (Standard Edition) "Data Capacity" based pricing',
    PLAN_ID_CAP_STANDARD_12M:
      'xCausal™ Standard (Standard Edition) "Data Capacity" based pricing',
    PLAN_ID_CODE_HEALTHCARE_1M:
      'xCausal™ for Healthcare (Healthcare Edition) "Number of Data" based pricing',
    PLAN_ID_CODE_HEALTHCARE_6M:
      'xCausal™ for Healthcare (Healthcare Edition) "Number of Data" based pricing',
    PLAN_ID_CODE_HEALTHCARE_12M:
      'xCausal™ for Healthcare (Healthcare Edition) "Number of Data" based pricing',
    PLAN_ID_CAP_HEALTHCARE_1M:
      'xCausal™ for Healthcare (Healthcare Edition) "Data Capacity" based pricing',
    PLAN_ID_CAP_HEALTHCARE_6M:
      'xCausal™ for Healthcare (Healthcare Edition) "Data Capacity" based pricing',
    PLAN_ID_CAP_HEALTHCARE_12M:
      'xCausal™ for Healthcare (Healthcare Edition) "Data Capacity" based pricing',

    PLAN_ID_LIGHT_1M:
      'xCausal™ Standard (Standard Edition) Lite Plan',
    PLAN_ID_LIGHT_6M:
      'xCausal™ Standard (Standard Edition) Lite Plan',
    PLAN_ID_LIGHT_12M:
      'xCausal™ Standard (Standard Edition) Lite Plan',

    PLAN_ID_TRIAL_LIGHT:
      'xCausal® Lite Plan',
    PLAN_ID_BASIC_1M:
      'xCausal®  Basic Plan',
    PLAN_ID_BASIC_6M:
      'xCausal®  Basic Plan',
    PLAN_ID_BASIC_12M:
      'xCausal®  Basic Plan',
    PLAN_ID_FLEX_1M:
      'xCausal®  Flex Plan',
    PLAN_ID_FLEX_6M:
      'xCausal®  Flex Plan',
    PLAN_ID_FLEX_12M:
      'xCausal®  Flex Plan',

    "corporate-health-file": "Please choose a file",

    "set-unit": "Set Unit",
    "unit-name": "Unit Name",
    "decimal-places": "Decimal Places",
    "data-type": "Imputation Type",
    "display-in-user-app": "Display in App",
    "vital-data-type": "Linear Interp (continuous data, etc.)",
    "event-data-type": "Zero Imputation (event data, etc.)",
    "update-settings": "Update Settings",

    "error-empty-columns": " must be completed.",

    "app-discret-title": "3.【Causal Inference Data Settings】",
    "app-discret-desc-2":
      "Set the discretization level values first, and if manual, determine the values that bound each level.\nThe causal hierarchy setting only allows causation to the same layer and the layer with the highest number.",
    "app-discret-desc-4":
      "※ Click the “Open Settings” button, confirm the settings, and then click the “Update Settings” button.",

    "app-discret-update-button": "Update Settings",
    "app-discret-unavailable-message":
      "{{names}} cannot be discretized due to large data bias. Please remove them from the CSV and upload again.\nNote: the CSV must contain at least 4 ID codes and at least 20 samples.",
    "app-discret-selection": "Selection",
    "app-discret-upload": "Data Item",
    "app-discret-levels": "Discretization Levels",
    "app-discret-range": "Discrete Range Setting",
    "app-discret-remove-outliers": "Remove Outliers",
    "app-discret-level-settings": "Causality Hierarchy Setting",
    "app-discret-boundary-values": "Discretization Settings",
    "app-discret-auto": "Automatic",
    "app-discret-manual": "Manual",
    "app-discret-on": "On",
    "app-discret-off": "Off",
    "app-discret-update-display": "Update Display",

    "node-table-ranking-label": "Relevance Rank",
    "node-table-item-name": "Item Name",
    "node-table-item-layer": "Layer",
    "node-table-number-of-people": "Number of ID Codes",
    "node-table-number-of-record": "Number of Records",

    "demo-graph-male": "Male",
    "demo-graph-female": "Female",

    "trial-popup-1":
      "You will not be charged during the 1 week free trial period.",
    "trial-popup-2":
      "※It will be automatically renewed after the free trial ends.",
    "trial-popup-3":
      "This plan requires a review of your registration information.",

    "error-auth": "Authorization Error. Please login again.",
    "error-within7days": "Data within 7 days cannot be analyzed at the moment.",
    "error-invalidValue": "Invalid Value.",
    "error-exceedMaxValue": "Maximum value exceeded.",
    "error-noOutcomeNode": "Please choose outcome node.",
    "error-noRelevanceNode": "Please choose relevance node.",
    "error-noData":
      "No data found with this set of conditions. Please try with other conditions.",
    "error-exceedMaxNumberOfNodes1": "Maximum of",
    "error-exceedMaxNumberOfNodes2": "nodes is allowed.",
    "error-api-unknown":
      "There was an error loading data from the server. Please try again later.",

    // NEW ERROR
    "error-check-username-and-password":
      "Please check your username or password",
    "communication-error": "Communication Error",
    "error-reenter-code": "Please enter the code again",
    "error-enter-code": "Please enter the code",
    "error-no-service-contract": "No service contract",
    "error-not-enough-items": "Not enough items",
    "error-no-data": "No data",
    "error-datetime-out-of-range": "Datetime data is out of range",
    "error-personal-code-user-not-found":
      "The user associated with the personal code cannot be found",
    "upload-error": "Upload error",
    "ten-items-error": "Up to 10 items can be displayed in the app",
    "error-incorrect-value-entered": "Incorrect value entered",
    "error-no-data-uploaded": "No data uploaded",
    "error-failed-update-settings": "Failed to update settings",
    "error-failed-get-data": "Failed to get data",
    "error-incorrect-value-set": "Incorrect value set",
    "error-check-with-doctor": "Please check with your doctor",
    "error-member-info-not-confirmed":
      "Member information could not be confirmed.",
    "error-select-plan": "Please select a plan",
    "error-logo-size-too-large": "Company logo size too large",
    "error-select-option": "Please select an option plan",
    "error-invalid-additional-account": "Invalid additional account.",

    "無料期間が終了します。": "The free trial will expire soon.",
    "継続して利用しますか？": "Will you  to use the service?",
    継続する: "Yes",
    継続しない: "No",
    スキップ: "skip",
    無料期間: "free trial",
    "（解約）": "(cancel)",
    "（継続）": "(subscribe)",
    期限切れ: "expired",
    は解約されます: "unsubscribe",
    初期に戻す: "Reset",

    // COMMON
    "common-confirm": "Confirm",
    "common-change-name": "Change Name",
    "common-delete": "Delete",
    "common-quarter-day": "1/4 day",
    "common-one-day": "1 day",
    "common-one-week": "1 week",
    "common-one-month": "1 month",
    "common-day": "day",
    "common-week": "week",
    "common-month": "month",

    "common-genders-label": "Gender",
    "common-male-label": "Male",
    "common-female-label": "Female",
    "common-other-label": "Other",
    "common-age-label": "years",
    "common-ages-label": "Age",
    "common-address-label": "Addresses",
    "common-days-label": "Days",
    "common-weeks-label": "Weeks",
    "common-months-label": "Months",
    "common-people-label": "",
    "common-basic-information-label": "Basic Information",
    "common-whole-body-label": "Whole Body",
    "common-whole-body-body-label": "Whole Body",
    "common-condition-label": "Condition",
    "common-worrisome-symptoms-label": "Symptoms",
    "common-location-label": "Location",
    "common-very-good-label": "Great",
    "common-good-label": "Good",
    "common-ok-label": "So-so",
    "common-bad-label": "Bad",
    "common-very-bad-label": "Terrible",

    "common-error-message": "Cannot be displayed due to an error.",

    "current-level": "Current Level",

    // TOP BAR
    "topbar-all-groups-label": "All Groups",
    "topbar-all-addresses-label": "All Regions",
    "topbar-all-ages-label": "All Ages",
    "topbar-no-upper-limit-label": "End",
    "topbar-filtering-label": "Population Filtering",
    "topbar-filter-conditions-label": "Conditions",
    "topbar-number-cases-label": "Cases",
    "topbar-from-label": "from",
    "topbar-to-label": "to",

    ...dataManager,
    ...dashboard,
    ...account,
    ...shared,
    ...graph,
    ...auth,
    ...assistant,
    ...cate,
    ...rca,
    ...augmentation,
  },
};

export default en;
